module.exports = __webpack_public_path__ + "img/circle-ellipsis.2cfab71b.svg";